export default {"src":"https://cdn.comverseglobal.com/alfa/_next/static/media/WorldWide.1342249e.svg","height":26,"width":19,"blurWidth":0,"blurHeight":0};